import { MapPin, Briefcase, ArrowRight } from 'lucide-react';
import MarketingLayout from './_layout';

const openings = [
  { title: 'Staff Backend Engineer', team: 'Platform', location: 'London / Remote', type: 'Full-time' },
  { title: 'Senior Product Designer', team: 'Design Systems', location: 'New York', type: 'Full-time' },
  { title: 'iOS Engineer', team: 'Mobile', location: 'Lisbon / Remote', type: 'Full-time' },
  { title: 'Solutions Architect', team: 'Enterprise', location: 'Singapore', type: 'Full-time' },
  { title: 'Customer Success Lead', team: 'Customer Experience', location: 'Remote (Americas)', type: 'Full-time' },
];

const perks = [
  'Competitive salary and meaningful equity',
  'Remote-first with optional hubs in London, NYC, Lisbon',
  '30 days paid time off + local public holidays',
  'Top-tier health, dental, and mental health coverage',
  'Annual learning and conference budget',
  'Home office stipend and yearly hardware refresh',
];

export default function CareersPage() {
  return (
    <MarketingLayout
      title="Careers at Messego"
      subtitle="Join us in building the operating system for the modern professional. We hire kind, curious, rigorous people."
    >
      <section className="space-y-12">
        <div className="space-y-6">
          <h2 className="text-2xl font-bold">Open roles</h2>
          <div className="space-y-3">
            {openings.map((role, i) => (
              <button
                key={i}
                className="w-full text-left p-6 bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-2xl flex items-center justify-between gap-6 hover:shadow-lg hover:-translate-y-0.5 transition-all"
              >
                <div className="space-y-1">
                  <h3 className="font-bold text-neutral-900 dark:text-neutral-50">{role.title}</h3>
                  <div className="flex flex-wrap gap-4 text-xs text-neutral-500 dark:text-neutral-400">
                    <span className="inline-flex items-center gap-1"><Briefcase size={12} />{role.team}</span>
                    <span className="inline-flex items-center gap-1"><MapPin size={12} />{role.location}</span>
                    <span>{role.type}</span>
                  </div>
                </div>
                <ArrowRight size={18} className="text-neutral-400 dark:text-neutral-500 flex-shrink-0" />
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-bold">Why Messego</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {perks.map((perk, i) => (
              <li key={i} className="p-4 bg-neutral-50 dark:bg-neutral-950 rounded-xl border border-neutral-200 dark:border-neutral-800 text-sm">
                {perk}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </MarketingLayout>
  );
}
